import React, {memo} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {filterMessages} from 'components/Filters/filterMessages'
import {FilterUrlParams} from 'modules/search/types'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Checkbox} from '@vio/atlas/src/components/designSystem/Checkbox'
import {cssTheme} from '@vio/atlas/themes'

const Wrapper = styled.div`
  display: grid;
  grid-gap: ${cssTheme.layout.spacing.s500};
`

interface Props {
  filters: FilterUrlParams
  handleSingleFilterChange: (value: FilterUrlParams) => void
}
const BookingOptionsFilterComponent: React.FC<Props> = ({
  filters,
  handleSingleFilterChange
}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  const isFreeCancellationFilterActive = filters.freeCancellation === '1'
  const isPayLaterFilterActive = filters.payLater === '1'

  return (
    <Wrapper>
      <Checkbox
        key="freeCancellation"
        name="freeCancellation"
        value="freeCancellation"
        checked={isFreeCancellationFilterActive}
        onChange={() =>
          handleSingleFilterChange({
            freeCancellation: isFreeCancellationFilterActive ? undefined : '1'
          })
        }
        label={formatMessage(filterMessages.freeCancellationTitle)}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
      <Checkbox
        key="payLater"
        name="payLater"
        value="payLater"
        checked={isPayLaterFilterActive}
        onChange={() =>
          handleSingleFilterChange({
            payLater: isPayLaterFilterActive ? undefined : '1'
          })
        }
        label={formatMessage(filterMessages.payLater)}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
    </Wrapper>
  )
}

export const BookingOptionsFilter = memo(BookingOptionsFilterComponent)
